export const startCustomInvitesOff =
  window.localStorage.getItem('startCustomInvitesOff') === 'true';
